import { CaseNoteResponse, SystemDropdownCategory, SystemDropdownParameter } from "@/api";
import { useSystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";
import { AppointmentAttendanceStatus } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";

export function useVisibleAppointmentStatus(caseNote: CaseNoteResponse): AppointmentAttendanceStatus | null {
  const { booleanParameterOf } = useSystemDropdownOptions(SystemDropdownCategory.CaseNoteType);

  if (!caseNote.appointmentStatus || !booleanParameterOf(caseNote.type, SystemDropdownParameter.Conversation)) {
    return null;
  }

  return caseNote.appointmentStatus as AppointmentAttendanceStatus;
}
